@if (isLarge && ratings?.numberOfReviews && !(hideRatingNumber === 'true')) {
  <ng-container *ngTemplateOutlet="numberOfReviews" />
}

@if (isLarge && !(hideRatingLabel === 'true')) {
  <ng-container *ngTemplateOutlet="averageRatingLabel" />
}

@if (!(hideRatingStars === 'true') || !(hideRatingLabel === 'true')) {
  <div class="c__ratings-block">
    @if (!(hideRatingStars === 'true')) {
      <fieldset>
        <sd-form-libelle
          [id]="'input-' + uuidRating"
          [labelHidden]="labelHidden"
          [labelTitle]="labelTitle"
          [required]="required"
        />
        @if (!readonly) {
          <div class="c__rating-stars" [attr.aria-hidden]="false">
            @for (rating of starQty; track rating) {
              <button
                type="button"
                #rateButton
                [attr.aria-disabled]="readonly"
                [tabIndex]="(readonly || ratings?.url) ? -1 : 0"
                sd-button-icon
                [brand]="brand"
                class="{{ $even ? 'is-half' : 'is-full'}}{{rateIndex($index) <= ratings?.averageRatings ? ' is-checked' : ''}}"
                [icon]="isScale
                  ? ($even ? 'icon-circle-filled-half' : 'icon-circle-filled')
                  : ($even ? 'icon-star-filled-half' : 'icon-star-filled')
                "
                (click)="selectRatings($index)"
                [size]="iconSize.small"
                [buttonIconTitle]="rateIndex($index) + ': ' + ('ratings.' + rating?.value | translate)"
                [attr.aria-pressed]="rateIndex($index) === ratings?.averageRatings"
              ></button>
            }
          </div>
        }
        @if (readonly) {
          <div #progressStars class="c__progress-bar-stars" [attr.aria-hidden]="false">
            <div class="c__svg-default-star-container">
              <svg [attr.width]="maxStar * (iconSizeStars + iconStarSpacing)">
                @for (i of starsTable; track i) {
                  <use
                    class="c__svg-default-star"
                    [attr.width]="iconSizeStars"
                    [attr.height]="iconSizeStars"
                    y="0"
                    [attr.href]="urlIcons + 'icons_' + (brand
                      ? brand?.toLowerCase()
                      : configBrand?.toLowerCase()) + '/icon-star-filled.svg#icon-star-filled'"
                    [attr.x]="i * (iconSizeStars + iconStarSpacing)"
                  />
                }
              </svg>
            </div>
            <div class="c__progress-bar-container">
              <div class="c__progress-bar-svg-container">
                <svg [attr.width]="maxStar * (iconSizeStars + iconStarSpacing)" [attr.height]="iconSizeStars">
                  <defs>
                    <mask [id]="'svg-mask-stars' + uuidMask">
                      @for (i of starsTable; track i) {
                        <use
                          class="c__svg-mask-stars"
                          [attr.width]="iconSizeStars"
                          [attr.height]="iconSizeStars"
                          y="0"
                          [attr.href]="urlIcons +  'icons_' + (brand
                            ? brand?.toLowerCase()
                            : configBrand?.toLowerCase()) + '/icon-star-filled-colored.svg#icon-star-filled-colored'"
                          [attr.x]="i * (iconSizeStars + iconStarSpacing)"
                        />
                      }
                    </mask>
                  </defs>
                  <rect width="100%" height="100%" x="0" y="0"/>
                </svg>
              </div>
            </div>
          </div>
        }
        @if (readonly) {
          <p class="is-visually-hidden">
            {{ 'ratings.' + ratings?.averageRatings | translate}}
          </p>
        }
      </fieldset>
    }
    @if (!isLarge && !(hideRatingLabel === 'true')) {
      <ng-container *ngTemplateOutlet="averageRatingLabel" />
    }
  </div>
}

@if (ratings?.numberOfReviews && showNumberOfReviews && !isLarge && !(hideRatingNumber === 'true')) {
  <ng-container *ngTemplateOutlet="numberOfReviews" />
}

<ng-template #averageRatingLabel>
  @if (showAverageRatingsLabel && ratings?.averageRatings !== undefined) {
    <p class="c__rating-label">
      <span class="c__note {{isLarge ? ' brand--h2' : ''}}">
        {{ ratings?.numberOfReviews ? ratings?.averageRatings : "-" }}
      </span>
      <span class="c__global-note {{isLarge ? ' brand--h5' : ''}}">
        /{{ maxStar }}
      </span>
      @if (!(hideRatingNumber === 'true')) {
        <span> - </span>
      }
  </p>
}
</ng-template>

<ng-template #numberOfReviews>
  @if (ratings?.numberOfReviews !== undefined && !ratings?.url) {
    <p class="c__reviews {{isLarge ? 'is-bold' : 'is-caption' }}"
      [ngClass]="{'is-full-area': reviewsClickable}"
      [class.is-link]="reviewsClickable"
      (click)="reviewsClickable && reviewsClicked.emit(ratings?.numberOfReviews)"
    >
      {{ ratings?.numberOfReviews }} {{ "ratings.reviews" | translate }}
    </p>
  }

  @if (indexFollow) {
    @if (ratings?.numberOfReviews !== undefined && ratings?.url && !isLarge) {
      <a class="c__reviews is-caption is-full-area"
        [attr.href]="ratings?.url"
        (click)="onReviewsSeeAllClicked()"
      >
        {{ ratings?.numberOfReviews }} {{ "ratings.reviews" | translate }}
      </a>
    }
  }

  @if (!indexFollow) {
    @if (ratings?.numberOfReviews !== undefined && ratings?.url && !isLarge) {
      <button class="c__reviews is-caption is-full-area is-reset is-link"
        (click)="onReviewsSeeAllClicked(ratings?.url)"
      >
        {{ ratings?.numberOfReviews }} {{ "ratings.reviews" | translate }}
      </button>
    }
  }
</ng-template>
